import React, { useEffect, useState } from "react";
import {UI_DELIMITER } from "../../../../utils/constants";
import FormRenderer, { ComponentMapper, FormTemplate, componentTypes } from "../../../common/FormRenderer";
import { getValue } from "../../../../utils/common";
import { Button, Modal } from "react-bootstrap";


function DepartmentUserDetails(this: any, { record: data, onClose, onSubmit }: any) {
    const [details, setDetails] = useState<any>({ hideButtons: true });

    const schema = {
        fields: [
            {
                component: componentTypes.PLAIN_TEXT,
                name: 'user',
                label: 'User',
                content: getValue(details, 'user.label'),
                formatOptionLabel: userOptionLabel
            },
            {
                component: componentTypes.PLAIN_TEXT,
                name: 'company',
                label: 'Company',
                content: getValue(details, 'company.label')
            },
            {
                component: componentTypes.PLAIN_TEXT,
                name: 'vertical',
                label: 'Vertical',
                content: getValue(details, 'vertical.label')
            },
            {
                component: componentTypes.PLAIN_TEXT,
                name: 'department',
                label: 'Department',
                content: getValue(details, 'department.label')
            }
        ],
    };

    function userOptionLabel({ label, user = {} }: any) {
        const roles = (user.userRoles || []).map(({name}: any) => name);
        return (
            <div className="d-flex flex-column">
                <div>{label}</div>
                <div className="text-sm fw-bold fst-italic text-wrap text-black-600">Role(s): {roles.join(UI_DELIMITER)}</div>
            </div>
        )
    }

    function getTitle() {
      return ' User Department Mapping Details';
    }

    useEffect(() => {
            if (data) {
                const { user, department } = data;
                const { vertical } = department || {};
                const { company } = vertical || {};
                setDetails({
                    hideButtons: true,
                    user: { value: (user || {}).id, label: (user||{}).name },
                    company: { value: company.id, label: company.name },
                    vertical: { value: vertical.id, label: vertical.name },
                    department: { value: (department || {}).id, label: (department || {}).name }
                });
            }
        }, [data]);

    return (
        <>
            <Modal show={true} backdrop="static" dialogClassName="drawer" animation={false}>
                <Modal.Header closeButton={true} onHide={onClose}>
                    <Modal.Title className="bg">{getTitle()}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <FormRenderer FormTemplate={FormTemplate}
                        initialValues={details}
                        componentMapper={ComponentMapper}
                        schema={schema}
                    />
                </Modal.Body>
                <Modal.Footer className="d-flex justify-content-between">
                    {
                      <Button variant="primary" onClick={onClose} className="px-4 ms-auto">{'Close'}</Button>
                    }
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default DepartmentUserDetails;
